import styled from 'styled-components';

export const NewsDetailSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media only screen and (max-width: 768px) {
    gap: 20px;
  }
`;

export const NewsDetailTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ContentHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media only screen and (max-width: 768px) {
    gap: 10px;
  }
`;

export const NewsDetailTitle = styled.h1`
  font-size: 54px;
  line-height: 56px;
  font-weight: 900;
  letter-spacing: -1px;
  margin: 0;

  @media only screen and (max-width: 768px) {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }
`;

export const BadgeLabel = styled.span`
  font-size: 12.65px;
  line-height: 12.65px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  background-color: #ffc800;
  padding: 4px 8px;

  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const ShareArticleLabel = styled.h6`
  font-size: 19px;
  font-weight: 700;
  margin: 0;
  display: block;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const PostContentWrapper = styled.div`
  position: relative;
  display: flex;
  gap: 30px;
`;

export const TagsContainer = styled.div`
  :before {
    content: '';
    display: block;
    width: 50px;
    height: 3px;
    background: #1e242f;
  }
`;

export const TagsWrapper = styled.div`
  display: flex;
  gap: 9px;
  align-items: flex-start;
  padding-top: 24px;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FloatingBoxWrapper = styled.div<{
  $show?: boolean;
}>`
  display: none;
  position: fixed;
  bottom: -80px;
  z-index: 999;
  background-color: white;
  margin-left: -20px;
  margin-right: -20px;
  width: 100%;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px -4px 16px 0px #00000014;
  will-change: top;
  opacity: 0;

  @media only screen and (max-width: 768px) {
    display: block;
    bottom: ${(props) => (props.$show ? 0 : '-80px')};
    opacity: 1;
  }
`;

export const FloatingBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
`;

export const AuthorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;

  @media only screen and (max-width: 768px) {
    margin: 10px 0;
  }
`;

export const FixedShareWrapper = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

export const ShareWrapper = styled.div`
  display: block;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const ListWrapper = styled.div`
  padding-right: 10px;

  @media only screen and (max-width: 991px) {
    padding-right: 0;
  }
`;
